// Module
var code = "<md-switch data-ng-model=debugModeSwitcherVm.isActivated aria-label=\"debug mode activation\" data-ng-change=debugModeSwitcherVm.onSwitcherModelChange()> <span translate>HEADER.DEBUG_MODE</span> </md-switch> ";
// Exports
module.exports = code;